import React from "react";
import TextField from "@mui/material/TextField";
import styles from "../../Styles/Creator_Form/pro.module.css";
import "../../Styles/Creator_Form/pro.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";

const ProInfo = ({ setMenu = (f) => f, handleChange = (f) => f, values }) => {
  return (
    <div className="infomain">
      <div className={styles.info}>
        <div className={styles.text}>
          <TextField
            label="Profession"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("profession")}
            value={values.profession}
          />
        </div>
        <div className={styles.text}>
          <TextField
            label="Past Experiences"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("pastexperiences")}
            value={values.pastexperiences}
          />
        </div>
        <div className={styles.text}>
          <TextField
            label="Relevant Skills"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("relevantskills")}
            value={values.relevantskills}
          />
        </div>
        <div className={styles.text}>
          <InputLabel id="demo-multiple-checkbox-label">
            PPT Knowledge:
          </InputLabel>
          <RadioGroup
            row
            aria-label="PPTknowledge"
            name="row-radio-buttons-group"
            value={values.pptknowledge}
            onChange={handleChange("pptknowledge")}
          >
            <FormControlLabel
              value="yes"
              control={
                <Radio
                  sx={{
                    "&.Mui-checked": {
                      color: "#4a1d85",
                    },
                  }}
                />
              }
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={
                <Radio
                  sx={{
                    "&.Mui-checked": {
                      color: "#4a1d85",
                    },
                  }}
                />
              }
              label="No"
            />
          </RadioGroup>
        </div>
        <div className={styles.text}>
          <TextField
            label="Social Platforms links"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("social")}
            value={values.social}
          />
        </div>
        <div className={styles.button}>
          <div className={styles.but1}>
            <button onClick={() => setMenu("basic")}>Previous</button>
          </div>
          <div className={styles.but2}>
            <button
              disabled={
                !values.profession ||
                !values.pastexperiences ||
                !values.pptknowledge ||
                !values.social ||
                !values.relevantskills
                  ? true
                  : false
              }
              onClick={() => setMenu("third")}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProInfo;
